<template>
    <Header v-if="!$route.meta.requireTemplate"/>
    <main>
        <router-view/>
    </main>
    <Footer v-if="!$route.meta.requireTemplate"/>
    <GoogleTagManager/>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import Header from '@/components/layout/Header.vue'; // @ is an alias to /src
import Footer from '@/components/layout/Footer.vue';
import GoogleTagManager from "@/components/misc/GoogleTagManager";

export default defineComponent({
    name: 'Home',
    components: {
        Header,
        Footer,
        GoogleTagManager
    }
});
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
@import "../node_modules/bootstrap/scss/bootstrap";

main {
    overflow-x: hidden;
}
</style>